import * as React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { getPasswordRuleResults } from "../utils/passwordRules";
import { AUTH_SUCCESS, AUTH_ERROR } from "../theme/appTheme";
import { useTranslation } from "../i18n/LanguageContext";

// Live checklist shown under a new-password field — each rule ticks green
// the moment it's satisfied, red (with a cross) until then.
function PasswordStrengthChecklist({ password, sx }) {
  const { t } = useTranslation();
  const results = getPasswordRuleResults(password, t);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.375, mt: 0.75, mb: 0.5, ...sx }}>
      {results.map((rule) => (
        <Box key={rule.key} sx={{ display: "flex", alignItems: "center", gap: 0.625 }}>
          {rule.passed ? (
            <CheckCircleRoundedIcon sx={{ fontSize: 13, color: AUTH_SUCCESS, flexShrink: 0 }} />
          ) : (
            <CancelRoundedIcon sx={{ fontSize: 13, color: AUTH_ERROR, flexShrink: 0 }} />
          )}
          <Typography sx={{ fontSize: "0.6875rem", lineHeight: 1.3, color: rule.passed ? AUTH_SUCCESS : AUTH_ERROR }}>
            {rule.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default PasswordStrengthChecklist;
